<template>
    <div class="top-line search-line">
        <span class="sk-title-small content-center" style="flex: 1">{{ title }}</span>
    </div>
    <div class="split-line"></div>
    <el-row>
        <el-col :span="24">
            <div class="picker-holder">
                <div class="icon-button icon-button-checked">
                    <span class="entity-icon entity-icon-jiequ"></span>
                    街区
                </div>
                <div class="icon-button">
                    <span class="entity-icon entity-icon-shangchang"></span>
                    商场
                </div>
                <div class="icon-button">
                    <span class="entity-icon entity-icon-shequ"></span>
                    社区
                </div>
                <div class="icon-button">
                    <span class="entity-icon entity-icon-zhengwu"></span>
                    公共服务
                </div>
                <div class="icon-text">
                    <el-popover placement="right-start" ref="popover" title="选择实体" :width="500" trigger="click">
                        <template #reference>
                            <el-input :readonly="true" v-model="entityName" placeholder="请选择" size="mini" style="width: 200px"></el-input>
                        </template>
                        <div style="height: 400px; overflow: auto">
                            <div style="padding: 10px">
                                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            </div>
                            <el-tree
                                class="my-tree"
                                ref="tree"
                                style="margin-top: 5px"
                                :data="dataList"
                                node-key="EntityID"
                                default-expand-all
                                highlight-current
                                :expand-on-click-node="false"
                                :filter-node-method="filterNode"
                                @node-click="handleNodeClick"
                            >
                                <template #default="{ data }">
                                    <div class="custom-tree-node">
                                        <span class="menu-icon icon-org" v-if="data.EntityType == 101"></span>
                                        <span class="menu-icon icon-shop" v-if="data.EntityType == 1"></span>
                                        <span class="menu-icon icon-floor" v-if="data.EntityType == 2"></span>
                                        <span class="menu-icon icon-market" v-if="data.EntityType == 3"></span>
                                        <span>{{ data.EntityName }}</span>
                                    </div>
                                </template>
                            </el-tree>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="picker-holder">
                <div class="icon-text" style="width: auto">
                    <el-radio-group v-model="type" size="mini">
                        <el-radio-button :label="1">实时数据</el-radio-button>
                        <el-radio-button :label="2">周报</el-radio-button>
                        <el-radio-button :label="3">月报</el-radio-button>
                        <el-radio-button :label="4">年报</el-radio-button>
                        <el-radio-button :label="5">自定义</el-radio-button>
                    </el-radio-group>
                    <el-date-picker v-model="date" v-if="type == 1" size="mini" type="date" placeholder="选择日期"> </el-date-picker>
                    <el-date-picker
                        v-model="date"
                        v-if="type == 2"
                        @change="changedWeek"
                        size="mini"
                        type="week"
                        format="gggg 第 ww 周"
                        placeholder="选择周"
                    >
                    </el-date-picker>
                    <el-date-picker v-model="date" v-if="type == 3" size="mini" type="month" placeholder="选择月"> </el-date-picker>
                    <el-date-picker v-model="date" v-if="type == 4" size="mini" type="year" placeholder="选择年"> </el-date-picker>
                    <el-date-picker
                        v-model="dates"
                        v-if="type == 5"
                        type="daterange"
                        size="mini"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </div>
                <div class="picker-holder">
                    <div class="icon-text" style="width: auto">
                        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
export default {
    name: "SearchLine1",
    props: {
        entitys: { type: Array },
    },
    components: {},
    data() {
        return {
            isShowDialog: false,
            entity: null,
            dataList: [],
            entityID: "",
            entityName: "",
            doorID: "",
            doorName: "",
            title: "",
            date: "",
            date1: "",
            date2: "",
            time1: "00:00",
            time2: "24:00",
            dates: [],
            type: 1,
        };
    },
    created() {
        this.initData();
        let data = this.$auth.getTokenData();
        if (data && data.Entity) {
            this.setSelectEntity(data.Entity);
        }
    },
    mounted() {
        this.getOrgEntityTree();
    },
    methods: {
        initData() {
            this.date = new Date().format("yyyy-MM-dd");
            this.dates = [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()];
            this.type = 1;
        },
        setSelectEntity(e) {
            this.entityID = e.EntityID;
            this.entityName = e.EntityName;
            this.changeTitle();
        },
        getOrgEntityTree() {
            this.$ajax.post("/Entity/GetEntityTree").then((res) => {
                if (res.Data) {
                    this.dataList = res.Data;
                    if (!this.entityID && this.dataList.length > 0) {
                        this.setSelectEntity(this.dataList[0]);
                    }
                } else {
                    this.dataList = [];
                }
                this.onSearch();
            });
        },
        handleNodeClick(data) {
            this.$refs.popover.hide();
            this.setSelectEntity(data);
        },
        onSearch() {
            if (this.type == 5) {
                this.date1 = new Date(this.dates[0]).format("yyyy-MM-dd");
                this.date2 = new Date(this.dates[1]).format("yyyy-MM-dd");
            } else {
                this.date1 = new Date(this.date).format("yyyy-MM-dd");
                this.date2 = new Date(this.date).format("yyyy-MM-dd");
            }
            let data = {
                Type: this.type,
                BeginTime: this.date1,
                EndTime: this.date2,
                ID: this.entityID,
                DoorID: this.doorID,
                IDType: 2,
                Time1: this.time1,
                Time2: this.time2,
            };
            this.$emit("search", data);
        },
        changeTitle() {
            let name = this.entityName;
            if (this.doorName) {
                name += this.doorName;
            }
            name += "人流综合数据统计";
            this.title = name;
        },
        getButtonClass(tp) {
            if (tp == this.type) {
                return "block-button button-report";
            }
            return "block-button button-normal";
        },
        changeType(tp) {
            this.type = tp;
        },
        showDialog() {
            this.isShowDialog = true;
        },
    },
};
</script>
<style scoped>
.block-button {
    margin-right: 10px;
}
.timePicker {
    width: 100px;
}
.timePicker:first-child {
    margin-left: 10px;
}
.icon-button {
    width: 65px;
    text-align: center;
    display: inline-block;
    padding: 10px;
}
.icon-text {
    width: 200px;
    text-align: center;
    display: inline-block;
    padding: 10px;
    height: 40px;
}
.picker-holder {
    margin-left: 80px;
}
.picker-holder .icon-button {
    float: left;
}
.picker-holder .icon-text {
    float: left;
    padding-top: 30px;
}
.entity-icon {
    display: block;
    width: 100%;
    height: 40px;
    background-position: center;
    background-repeat: no-repeat;
}

.icon-button .entity-icon-jiequ {
    background-image: url("/images/wsj/icon-jiedao.png");
}
.icon-button-checked .entity-icon-jiequ {
    background-image: url("/images/wsj/icon-jiedao1.png");
}
.icon-button .entity-icon-shangchang {
    background-image: url("/images/wsj/icon-shangchang.png");
}
.icon-button-checked .entity-icon-shangchang {
    background-image: url("/images/wsj/icon-shangchang1.png");
}
.icon-button .entity-icon-shequ {
    background-image: url("/images/wsj/icon-shequ.png");
}
.icon-button-checked .entity-icon-shequ {
    background-image: url("/images/wsj/icon-shequ1.png");
}
.icon-button .entity-icon-zhengwu {
    background-image: url("/images/wsj/icon-zhengwu.png");
}
.icon-button-checked .entity-icon-zhengwu {
    background-image: url("/images/wsj/icon-zhengwu1.png");
}
</style>
